import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Modal, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import Heroallcourse from './Herocourse';

const PasswordReset = () => {
  const { token } = useParams(); // Extract token from URL params
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setShowModal(true);
  }, []);

  const handleClose = () => {
    setShowModal(false);
    navigate('/loginall'); // Replace '/some-other-page' with your desired path
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true); // Start loading state
    try {
      await axios.post('https://djangomyaip.hoseconsultsugandaltd.com/api/password_reset/confirm/', {
        token: token,
        password: newPassword,
      });
      setSuccess('Password reset successfully. You can now log in with your new password.');
      setError('');
    } catch (err) {
      setError('Failed to reset password. Please try again.');
      setSuccess('');
    } finally {
      setLoading(false); // Stop loading state
    }
  };

  return (
    <>
      <Heroallcourse />
      <Modal
        show={showModal}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Reset Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {success && <Alert variant="success">{success}</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}
          {!success ? (
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="formNewPassword">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  className="custom-input"
                />
              </Form.Group>

              <Form.Group controlId="formConfirmPassword">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  className="custom-input"
                />
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                className="custom-button"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    {' Please wait...'}
                  </>
                ) : (
                  'Reset Password'
                )}
              </Button>
            </Form>
          ) : (
            <Button variant="primary" onClick={handleClose} className="custom-button">
              Login
            </Button>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PasswordReset;
